export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20illustration%20of%20a%20cozy%20reading%20corner%20with%20bookshelves%20full%20of%20colorful%20manga%20volumes%2C%20soft%20warm%20lighting%20from%20a%20lamp%2C%20comfortable%20chair%2C%20plants%2C%20artistic%20atmosphere%20with%20gentle%20gradients%2C%20warm%20cream%20and%20terracotta%20tones%2C%20editorial%20style%2C%20no%20text&width=800&height=600&seq=about-01&orientation=landscape"
                alt="YY漫画品牌形象 - 温暖舒适的漫画阅读空间"
                className="w-full h-full object-cover rounded-2xl"
                loading="lazy"
              />
            </div>
          </div>
          <div className="flex-1 w-full">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">关于YY漫画</h2>
            <div className="mt-4 w-12 h-1 bg-primary-500 rounded-full"></div>
            <p className="mt-5 text-sm text-foreground-600 leading-relaxed">
              YY漫画诞生于一群资深漫迷的热爱。我们深知追更的焦虑、找资源的麻烦、以及遇到一部好漫画时的狂喜。正因如此，我们打造了这个集追更提醒、智能收藏、个性化推荐于一体的漫画阅读平台。
            </p>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              平台收录超过 <strong className="text-primary-500">5 万部</strong> 韩漫和日漫作品，涵盖热血、恋爱、奇幻、武侠、悬疑等全品类。我们采用流畅的下拉式阅读体验，让你沉浸在漫画世界中不受打断。每日更新超过 <strong className="text-primary-500">100 话</strong>，日均服务 <strong className="text-primary-500">80 万</strong> 漫迷。
            </p>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              无论你是热衷韩漫的 Webtoon 爱好者，还是日漫经典殿堂的忠实粉丝，YY漫画都为你准备了最全的漫画大全和最贴心的追更体验。在这里，找到属于你的阅读节奏。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-primary-100 text-primary-700 text-sm font-medium whitespace-nowrap">
                <i className="ri-checkbox-circle-line"></i> 免费全集
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-accent-100 text-accent-700 text-sm font-medium whitespace-nowrap">
                <i className="ri-checkbox-circle-line"></i> 正版资源
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-secondary-100 text-secondary-700 text-sm font-medium whitespace-nowrap">
                <i className="ri-checkbox-circle-line"></i> 每日更新
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}